import { Directive, ElementRef, EventEmitter, OnDestroy, Output } from '@angular/core';

@Directive({ selector: '[appClickOutside]', standalone: false })
export class ClickOutsideDirective implements OnDestroy {
  @Output() appClickOutside = new EventEmitter<void>();
  constructor(private el: ElementRef) {
    this.listener = this.handleClick.bind(this);
    document.addEventListener('click', this.listener);
  }
  private listener: any;
  handleClick(event: MouseEvent) {
    if (!this.el.nativeElement.contains(event.target)) {
      this.appClickOutside.emit();
    }
  }
  ngOnDestroy() {
    document.removeEventListener('click', this.listener);
  }
}
